// extracted by mini-css-extract-plugin
export default {"commentCard":"CommentCard_commentCard__Ty9US","meta":"CommentCard_meta__+TkKV","metaItem":"CommentCard_metaItem__10ZbU","deleteButton":"CommentCard_deleteButton__yOrZy"};